export default "__VITE_ASSET__CzeTBeEF__"